/* This is the smallest integer that is evenly divisible by 2, 3, 4, and 5, ensuring a visually pleasing grid layout across all screen sizes.*/
export const TOKEN_QUERY_LIMIT = 60;

export type QueryParams = {
  q?: string;
  sortBy?: string;
  from?: string;
  to?: string;
  maxRarityRank?: string;
};
